import React, { lazy } from "react";
import LazyLoading from "../../common/components/LazyLoading/LazyLoading";
import { Navigate } from "react-router-dom";
const ServicesPage = lazy(() =>
  import(
    "../../pages/Services/ServicesContainer/components/ServicePage/ServicePage"
  )
);
const ServiceId = lazy(() =>
  import("../../pages/Services/service-id/ServiceId")
);

const ServicesSelectProperty = lazy(() =>
  import(
    "../../pages/Services/ServicesContainer/components/SelectProperty/SelecteProperty"
  )
);
const ServicesFillDetails = lazy(() =>
  import(
    "../../pages/Services/ServicesContainer/components/FillDetails/FillDetails"
  )
);

const serviceRoutes = [
  // {
  //   path: "",
  //   // element: <Navigate to="" replace />,

  //   element: (
  //     <LazyLoading>
  //       <Services />
  //     </LazyLoading>
  //   ),
  // },
  {
    path: "",
    element: (
      <LazyLoading>
        <ServiceId />
      </LazyLoading>
    ),
  },
  {
    path: ":category/:serviceSlug",
    element: (
      <LazyLoading>
        <ServicesPage />
      </LazyLoading>
    ),
  },

  {
    path: ":category/:serviceSlug/selectproperty",
    element: (
      <LazyLoading>
        <ServicesSelectProperty />
      </LazyLoading>
    ),
  },
  {
    path: ":category/:serviceSlug/selectproperty/filldetails",
    element: (
      <LazyLoading>
        <ServicesFillDetails />
      </LazyLoading>
    ),
  },
];

export default serviceRoutes;
